export default __webpack_public_path__ + "static/pushfusion-intro-cce78834145a9d609d247afe8a394e67.mp4";